import { Club, Shot, Target } from "../store/Session/SessionModel";

export const getClubColor = (clubType: string, clubColor: string) => {
    if (clubColor) return '#' + clubColor.replace('#', '').padStart(6, '0');
    switch (clubType.toLowerCase()) {
        case "driver":
            return "#4BC3FF";
        case "wood3":
            return "#FF4B4B";
        case "wood5":
            return "#D2FF4B";
        case "hybrid2":
            return "#FF66FF";
        case "hybrid4":
            return "#638AFF";
        case "iron1":
            return "#CCFF90";
        case "iron3":
            return "#45EB53";
        case "iron4":
            return "#FFE14B";
        case "iron5":
            return "#FF2B51";
        case "iron6":
            return "#4BFFF0";
        case "iron7":
            return "#BF66FF";
        case "iron8":
            return "#FF964B";
        case "iron9":
            return "#8BF556";
        case "pitchingwedge":
            return "#7F66FF";
        case "sandwedge":
            return "#4BFFA5";
        case "lobwedge":
            return "#FF529A";
        case "wood2":
        case "wood4":
        case "wood6":
        case "wood7":
        case "wood8":
        case "wood9":
            return "#B388FF";
        case "hybrid1":
        case "hybrid3":
        case "hybrid5":
        case "hybrid6":
        case "hybrid7":
        case "hybrid8":
        case "hybrid9":
            return "#F4FF81";
        case "gapwedge":
        case "approachwedge":
        case "wedge46":
        case "wedge48":
        case "wedge50":
        case "wedge52":
        case "wedge54":
        case "wedge56":
        case "wedge58":
        case "wedge60":
        case "wedge62":
        case "wedge64":
            return "#84FFFF";
        default:
            return "#B0BEC5";
    }
}

export const getClubName = (clubType: string) => {
    switch (clubType.toLowerCase()) {
        case "driver":
            return "Driver";
        case "wood2":
            return "2 wood";
        case "wood3":
            return "3 wood";
        case "wood4":
            return "4 wood";
        case "wood5":
            return "5 wood";
        case "wood6":
            return "6 wood";
        case "wood7":
            return "7 wood";
        case "wood8":
            return "8 wood";
        case "wood9":
            return "9 wood";
        case "hybrid":
            return "Hybrid";
        case "hybrid1":
            return "1 hybrid";
        case "hybrid2":
            return "2 hybrid";
        case "hybrid3":
            return "3 hybrid";
        case "hybrid4":
            return "4 hybrid";
        case "hybrid5":
            return "5 hybrid";
        case "hybrid6":
            return "6 hybrid";
        case "hybrid7":
            return "7 hybrid";
        case "hybrid8":
            return "8 hybrid";
        case "hybrid9":
            return "9 hybrid";
        case "putter":
            return "Putter";
        case "iron1":
            return "1 iron";
        case "iron2":
            return "2 iron";
        case "iron3":
            return "3 iron";
        case "iron4":
            return "4 iron";
        case "iron5":
            return "5 iron";
        case "iron6":
            return "6 iron";
        case "iron7":
            return "7 iron";
        case "iron8":
            return "8 iron";
        case "iron9":
            return "9 iron";
        case "pitchingwedge":
            return "Pitching Wedge";
        case "sandwedge":
            return "Sand Wedge";
        case "lobwedge":
            return "Lob Wedge";
        case "approachwedge":
            return "Approach Wedge";
        case "gapwedge":
            return "Gap Wedge";
        case "wedge46":
            return "46° Wedge";
        case "wedge48":
            return "48° Wedge";
        case "wedge50":
            return "50° Wedge";
        case "wedge52":
            return "52° Wedge";
        case "wedge54":
            return "54° Wedge";
        case "wedge56":
            return "56° Wedge";
        case "wedge58":
            return "58° Wedge";
        case "wedge60":
            return "60° Wedge";
        case "wedge62":
            return "62° Wedge";
        case "wedge64":
            return "64° Wedge";
        case "nondefaultwoods":
            return "Non Default Woods";
        case "nondefaulthybrids":
            return "Non Default Hybrids";
        case "nondefaultwedges":
            return "Non Default Wedges";
        default:
            return clubType;
    }
}

export const getClubIconText = (str: string) => {
    const capitalLettersRegex = /[A-Z0-9]/g;
    const capitalLettersArray = str.match(capitalLettersRegex);
    const capitalLetters = capitalLettersArray ? capitalLettersArray.join('') : '';
    return capitalLetters.length ? capitalLetters : ((str && str.length && str[0].toUpperCase()) || "");
}

export const getClubTypeAbbreviation = (clubType: string) => {
    switch (clubType.toLowerCase()) {
        case "driver":
            return "D";
        case "wood2":
            return "2W";
        case "wood3":
            return "3W";
        case "wood4":
            return "4W";
        case "wood5":
            return "5W";
        case "wood6":
            return "6W";
        case "wood7":
            return "7W";
        case "wood8":
            return "8W";
        case "wood9":
            return "9W";
        case "hybrid":
            return "H";
        case "hybrid1":
            return "1H";
        case "hybrid2":
            return "2H";
        case "hybrid3":
            return "3H";
        case "hybrid4":
            return "4H";
        case "hybrid5":
            return "5H";
        case "hybrid6":
            return "6H";
        case "hybrid7":
            return "7H";
        case "hybrid8":
            return "8H";
        case "hybrid9":
            return "9H";
        case "putter":
            return "P";
        case "iron1":
            return "1i";
        case "iron2":
            return "2i";
        case "iron3":
            return "3i";
        case "iron4":
            return "4i";
        case "iron5":
            return "5i";
        case "iron6":
            return "6i";
        case "iron7":
            return "7i";
        case "iron8":
            return "8i";
        case "iron9":
            return "9i";
        case "pitchingwedge":
            return "PW";
        case "sandwedge":
            return "SW";
        case "lobwedge":
            return "LW";
        case "approachwedge":
            return "AW";
        case "gapwedge":
            return "GW";
        case "wedge46":
            return "46";
        case "wedge48":
            return "48";
        case "wedge50":
            return "50";
        case "wedge52":
            return "52";
        case "wedge54":
            return "54";
        case "wedge56":
            return "56";
        case "wedge58":
            return "58";
        case "wedge60":
            return "60";
        case "wedge62":
            return "62";
        case "wedge64":
            return "64";
        case "nondefaultwoods":
            return "W";
        case "nondefaulthybrids":
            return "H";
        case "nondefaultwedges":
            return "W";
        default:
            return clubType.charAt(0);
    }
}

export const clubOrder = [
    "Driver",
    "Wood2",
    "Wood3",
    "Wood4",
    "Wood5",
    "Wood6",
    "Wood7",
    "Wood8",
    "Wood9",
    "Hybrid",
    "Hybrid1",
    "Hybrid2",
    "Hybrid3",
    "Hybrid4",
    "Hybrid5",
    "Hybrid6",
    "Hybrid7",
    "Hybrid8",
    "Hybrid9",
    "Iron1",
    "Iron2",
    "Iron3",
    "Iron4",
    "Iron5",
    "Iron6",
    "Iron7",
    "Iron8",
    "Iron9",
    "PitchingWedge",
    // Named wedges run in loft order, the way the Golf App lists them:
    // PW → GW/AW → SW → LW. Gap and approach wedge are the same club under
    // two names, so their relative order only matters for a set that has both.
    "GapWedge",
    "ApproachWedge",
    "SandWedge",
    "LobWedge",
    "Wedge46",
    "Wedge48",
    "Wedge50",
    "Wedge52",
    "Wedge54",
    "Wedge56",
    "Wedge58",
    "Wedge60",
    "Wedge62",
    "Wedge64",
    "Putter",
    "Other"
]

/**
 * Position of a club type in the display order.
 * Types missing from `clubOrder` (e.g. "Unknown") sort last instead of first,
 * which is what a raw `indexOf` would do via its -1 result.
 */
export const getClubOrderIndex = (clubType: string) => {
    const index = clubOrder.indexOf(clubType);
    return index === -1 ? clubOrder.length : index;
}

export const dummyClubsData: Club = {
    clubId: "",

    isActive: false,
    isShowShots: false,
    isNormalized: false,

    clubName: "",
    clubType: "",
    clubCategory: "",
    clubNickname: "",
    clubColor: "",
    clubIcon: "",

    totalShots: 0,
    selectedTimestamp: 0,
    average: {
        quality: {
            uom: "",
            value: "---",
            label: "QUALITY"
        },
        distanceToPin: {
            uom: "",
            value: "---",
            label: "PROXIMITY"
        },
        carryDistance: {
            uom: "",
            value: "---",
            label: "CARRY"
        },
        spinRate: {
            uom: "",
            value: "---",
            label: "SPIN RATE"
        },
        ballSpeed: {
            uom: "",
            value: "---",
            label: "BALL SPEED"
        },
        clubSpeed: {
            uom: "",
            value: "---",
            label: "CLUB SPEED"
        },
        smashFactor: {
            uom: "",
            value: "---",
            label: "SMASH FACTOR"
        },
        apex: {
            uom: "",
            value: "---",
            label: "APEX"
        },
        launchAngle: {
            uom: "",
            value: "---",
            label: "LAUNCH ANGLE"
        },
        totalDistance: {
            uom: "",
            value: "---",
            label: "TOTAL"
        },
        descentAngle: {
            uom: "",
            value: "---",
            label: "DESCENT ANGLE"
        },

        clubPath: {
            uom: "",
            value: "---",
            label: "CLUB PATH"
        },
        faceAngle: {
            uom: "",
            value: "---",
            label: "FACE ANGLE"
        },
        attackAngle: {
            uom: "",
            value: "---",
            label: "ATTACK ANGLE"
        },
        faceToPath: {
            uom: "",
            value: "---",
            label: "FACE TO PATH"
        },

        spinAxis: {
            uom: "",
            value: "---",
            label: "SPIN AXIS"
        },
        horizontalLaunchAngle: {
            uom: "",
            value: "---",
            label: "HORIZ. ANGLE"
        },
        side: {
            uom: "",
            value: "---",
            label: "SIDE CARRY"
        },
    },
    shots: []
}
export const dummyTargetsData: Target = {
    targetId: '',

    isActive: false,
    isShowShots: false,
    isNormalized: false,


    totalShots: 0,
    average: {
        quality: {
            uom: "",
            value: "---",
            label: "QUALITY"
        },
        distanceToPin: {
            uom: "",
            value: "---",
            label: "PROXIMITY"
        },
        carryDistance: {
            uom: "",
            value: "---",
            label: "CARRY"
        },
        spinRate: {
            uom: "",
            value: "---",
            label: "SPIN RATE"
        },
        ballSpeed: {
            uom: "",
            value: "---",
            label: "BALL SPEED"
        },
        clubSpeed: {
            uom: "",
            value: "---",
            label: "CLUB SPEED"
        },
        smashFactor: {
            uom: "",
            value: "---",
            label: "SMASH FACTOR"
        },
        apex: {
            uom: "",
            value: "---",
            label: "APEX"
        },
        launchAngle: {
            uom: "",
            value: "---",
            label: "LAUNCH ANGLE"
        },
        totalDistance: {
            uom: "",
            value: "---",
            label: "TOTAL"
        },
        descentAngle: {
            uom: "",
            value: "---",
            label: "DESCENT ANGLE"
        },

        clubPath: {
            uom: "",
            value: "---",
            label: "CLUB PATH"
        },
        faceAngle: {
            uom: "",
            value: "---",
            label: "FACE ANGLE"
        },
        attackAngle: {
            uom: "",
            value: "---",
            label: "ATTACK ANGLE"
        },
        faceToPath: {
            uom: "",
            value: "---",
            label: "FACE TO PATH"
        },

        spinAxis: {
            uom: "",
            value: "---",
            label: "SPIN AXIS"
        },
        horizontalLaunchAngle: {
            uom: "",
            value: "---",
            label: "HORIZ. ANGLE"
        },
        side: {
            uom: "",
            value: "---",
            label: "SIDE CARRY"
        },
    },
    shots: []
}

export const getClubId = (shot: Shot) => {
    if (shot.clubId) return shot.clubId;
    if (shot.clubName) return `${shot.clubType}|${shot.clubName}`;
    return shot.clubType;
}